import React from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
// REMOVE THESE IMPORTS, as their content is now embedded or handled differently:
// import Services from "./Services";
// import Biqua from "./Biqua";
// import QuantumComputing from "./QuantumComputing";
// import More from "./More";
// import Contact from "./Contact";

const FOOTER_API_URL = "https://glocybs.com"; // Define here or import from config

// Services Sidebar Content (moved from original Services.jsx)
const ServicesSidebarContent = ({ toggleSidebar }) => {
    return (
        <div className="flex flex-col p-4 text-black">
            <div className="text-center mb-4">
                <h2 className="text-lg font-bold text-red-500">All Services</h2>
            </div>
            <div className="flex justify-start mb-4">
                <a href={`${FOOTER_API_URL}/services`} className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full inline-block" onClick={toggleSidebar}>
                    Explore Platform <span className="ml-2">→</span>
                </a>
            </div>
            <div className="border-b-2 border-red-500 mb-8"></div>
            <div className="grid grid-cols-1 gap-4 text-left">
                <div><a href={`${FOOTER_API_URL}/services/ai-defense`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>AI DEFENSE</a><p className="text-gray-600">Utilizes adaptive intelligence and advanced AI to forecast, identify, and stop cyber threats.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/blockchain-security`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>BLOCKCHAIN SECURITY</a><p className="text-gray-600">Strengthens your blockchain with AI-powered audits and multi-layered security, ensuring data integrity and protection from threats</p></div>
                <div><a href={`${FOOTER_API_URL}/services/organizational-security`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>ORGANIZATIONAL SECURITY</a><p className="text-gray-600">Provides comprehensive organizational security by protecting your data, devices, and employees against internal and external attacks.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/website-security`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>WEBSITE SECURITY</a><p className="text-gray-600">Offers comprehensive website security with multi-layered protection, and 24/7 threat monitoring.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/database-security`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>DATABASE SECURITY</a><p className="text-gray-600">Deliver powerful database security solutions that protect sensitive information with enhanced protection.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/data-loss-protection`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>DATA LOSS PROTECTION (DLP)</a><p className="text-gray-600">Protect your organization with our complete data loss prevention service, which protects essential information from unauthorized access and accidental breaches.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/cyber-security-insurance`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>CYBER SECURITY INSURANCE BROKERAGE</a><p className="text-gray-600">Secure your business with our expert cybersecurity insurance brokerage, designed to protect against digital risks and financial losses. </p></div>
                <div><a href={`${FOOTER_API_URL}/services/managed-detection-response`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>MANAGED DETECTION AND RESPONSE</a><p className="text-gray-600">Stay secure 24/7 with Managed Detection and Response, providing expert threat detection and immediate response.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/identity-access-management`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>IDENTITY AND ACCESS MANAGEMENT (IAM)</a><p className="text-gray-600">Securely manage who accesses what, when, and how with our Identity and Access Management (IAM) service.</p></div>
                <div><a href={`${FOOTER_API_URL}/services/digital-forensics`} className="font-bold text-gray-800 mb-2 hover:text-red-500 transition-colors duration-200" onClick={toggleSidebar}>DIGITAL FORENSICS</a><p className="text-gray-600">Investigating and interpreting digital footprints to secure your operations with our digital forensic service.</p></div>
            </div>
        </div>
    );
};

// Biqua Sidebar Content (moved from original Biqua.jsx)
const BiquaSidebarContent = ({ toggleSidebar }) => {
    return (
        <div className="flex flex-col p-4 text-black">
            <div className="grid grid-col-1 gap-4 text-left space-y-4">
                <div>
                    <a href={`${FOOTER_API_URL}/biqua/blockchain`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Blockchain</a>
                    <div className='border-t-2 border-blue-600 w-full mt-[5%]'></div>
                    <p className="text-sm text-left mt-[10%]">Allows for the verification of data without revealing the data itself, enhancing privacy.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Consensus Mechanisms</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Smart Contract Security</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Encryption and Privacy</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Secure Key Management</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Network Security</a></li>
                    </ul>
                </div>
                <div>
                    <a href={`${FOOTER_API_URL}/biqua/innovation`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Innovation</a>
                    <div className='border-t-2 border-blue-600 w-full mt-[5%]'></div>
                    <p className="text-sm text-left mt-[10%]">AI-driven systems can learn and recognize normal user behavior patterns and detect anomalies that may indicate a security breach.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Behavioural Analysis</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Post-Quantum Algorithms</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Decentralized Autonomous Organizations (DAOs)</a></li>
                        <li><a href="#" onClick={toggleSidebar}>User and Entity Behaviour Analytics (UEBA)</a></li>
                    </ul>
                </div>
                <div>
                    <a href={`${FOOTER_API_URL}/biqua/quantum-computing`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Quantum Computing</a>
                    <div className='border-t-2 border-blue-600 w-full mt-[5%]'></div>
                    <p className="text-sm text-left mt-[10%]">Research and develop a quantum internet infrastructure for ultra-secure communication channels using quantum entanglement.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum-Resistant Encryption</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Quantum-Secure Networks</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Advanced Threat Detection</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Optimization of Security Protocols</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Secure Data Storage</a></li>
                    </ul>
                </div>
                <div>
                    <a href={`${FOOTER_API_URL}/biqua/artificial-intelligence`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Artificial Intelligence</a>
                    <div className='border-t-2 border-blue-600 w-full mt-[5%]'></div>
                    <p className="text-sm text-left mt-[10%]">AI can improve the accuracy and security of biometric authentication methods, such as facial recognition, fingerprint scanning, and voice recognition, reducing the risk of unauthorized access.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Enhanced Access Control and Authentication</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Fraud Detection and Prevention</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

// Quantum Computing Sidebar Content (moved from original QuantumComputing.jsx)
const QuantumComputingSidebarContent = ({ toggleSidebar }) => {
    return (
        <div className="flex flex-col p-4 text-black">
            <div className="grid grid-cols-1 gap-4 text-left space-y-4">
                <div>
                    <a href={`${FOOTER_API_URL}/quantum-computing/cryptanalysis`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Authentication and Identity Management</a>
                    <p className='border-b-4 border-blue-500 mt-[12%]'></p>
                    <p className="text-sm text-left mt-[10%]">Use quantum computing to enhance biometric authentication methods, making them more secure and harder to spoof.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum Biometrics</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Decentralized Identity Verification</a></li>
                    </ul>
                </div>
                <div>
                    <a href={`${FOOTER_API_URL}/quantum-computing/cryptanalysis`} className="text-red-500 font-bold pb-2" onClick={toggleSidebar}>Cryptanalysis</a>
                    <p className='border-b-4 border-blue-500 mt-[12%]'></p>
                    <p className="text-sm text-left mt-[10%]">Investigate quantum algorithms, such as Shor's algorithm, to understand their implications for breaking classical cryptographic systems and develop countermeasures.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum Cryptanalysis Research</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Quantum Random Number Generation (QRNG)</a></li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-red-500 font-bold pb-2">Incident Response and Recovery</h3>
                    <p className='border-b-4 border-blue-500'></p>
                    <p className="text-sm text-left mt-[10%]">Test the resilience of cybersecurity systems against potential quantum attacks to ensure they can withstand future threats.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum-Enhanced Forensics</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Quantum Resilience Testing</a></li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-red-500 font-bold pb-2">Secure Software Development</h3>
                    <p className='border-b-4 border-blue-500'></p>
                    <p className="text-sm text-left mt-[10%]">Use quantum computing for advanced static and dynamic code analysis to identify vulnerabilities and security flaws in software.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum-Enhanced Code Analysis</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Quantum-Proof Software Design</a></li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-red-500 font-bold pb-2">Training and Education</h3>
                    <p className='border-b-4 border-blue-500 mt-[12%]'></p>
                    <p className="text-sm text-left mt-[10%]">Provide specialized training for cybersecurity professionals on quantum computing and its implications for security.</p>
                    <ul className="mt-4 space-y-5 font-bold">
                        <li><a href="#" onClick={toggleSidebar}>Quantum Cybersecurity Training</a></li>
                        <li><a href="#" onClick={toggleSidebar}>Collaborative Research Initiatives</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

// More Sidebar Content (moved from original More.jsx)
const MoreSidebarContent = ({ toggleSidebar }) => {
    return (
        <div className="flex flex-col p-4 text-black">
            <h2 className="text-red-500 font-bold text-xl mb-2">More</h2>
            <div className="h-1 bg-gradient-to-r from-red-500 to-blue-500 mb-6"></div>
            <div className="grid grid-cols-1 gap-4 text-left">
                <div>
                    <ul className="space-y-8">
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/AIPredictiveAnalytics`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">AI-Driven Predictive Analytics</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/AIPoweredSOCs`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">AI-Powered Security Operations Centers (SOCs)</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/AIInsiderThreatDetection`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">AI for Insider Threat Detection</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/EthicalAICybersecurity`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Ethical and Responsible AI Use in Cybersecurity</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/FutureTrends`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Future Trends and Innovations in AI-Cybersecurity Integration</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/more/careers`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Careers</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

// Contact Sidebar Content (moved from original Contact.jsx)
const ContactSidebarContent = ({ toggleSidebar }) => {
    return (
        <div className="flex flex-col p-4 text-black">
            <h2 className="text-red-500 font-bold text-xl mb-2">Contact</h2>
            <div className="h-1 bg-gradient-to-r from-red-500 to-blue-500 mb-6"></div>
            <div className="grid grid-cols-1 gap-4 text-left">
                <div>
                    <ul className="space-y-8">
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/contact/leadership`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Our Teams</a></li>
                        <li className="mb-2"><a href="#" onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Contact Information</a></li>
                        <li className="mb-2"><a href={`${FOOTER_API_URL}/contact/form`} onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Contact Form</a></li>
                        <li className="mb-2"><a href="#" onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">FAQ Section</a></li>
                        <li className="mb-2"><a href="#" onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Feedback and Support</a></li>
                        <li className="mb-2"><a href="#" onClick={toggleSidebar} className="text-gray-800 hover:text-red-500">Privacy and Data Protection Notice</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const [isServicesOpen, setIsServicesOpen] = React.useState(false);
    const [isBiquaOpen, setIsBiquaOpen] = React.useState(false);
    const [isQuantumComputingOpen, setIsQuantumComputingOpen] = React.useState(false);
    const [isMoreOpen, setIsMoreOpen] = React.useState(false);
    const [isContactOpen, setIsContactOpen] = React.useState(false);

    const toggleServices = () => {
        setIsServicesOpen(!isServicesOpen);
    }
    const toggleBiqua = () => {
        setIsBiquaOpen(!isBiquaOpen);
    }
    const toggleQuantumComputing = () => {
        setIsQuantumComputingOpen(!isQuantumComputingOpen);
    }
    const toggleMore = () => {
        setIsMoreOpen(!isMoreOpen);
    }
    const toggleContact = () => {
        setIsContactOpen(!isContactOpen);
    }

    return (
        <div className={`fixed inset-0 mt-16 bg-white z-[60] flex flex-col overflow-y-auto transition-transform duration-300 ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
            <div className="flex flex-col p-4">
                {/* Services */}
                <div className="relative my-4">
                    <a href="#" className="flex justify-between items-center text-black text-2xl pb-4 w-full pl-4">
                        Services
                        <button onClick={toggleServices} className="text-2xl">
                            {isServicesOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                    </a>
                    <div className={`absolute left-0 right-0 bottom-0 h-0.5 bg-gradient-to-r from-green-500 to-yellow-500`} />
                </div>
                {isServicesOpen && <ServicesSidebarContent toggleSidebar={toggleSidebar}/>}

                {/* BIQUA */}
                <div className="relative my-4">
                    <a href="#" className="flex justify-between items-center text-black text-2xl pb-4 w-full pl-4">
                        BIQUA
                        <button onClick={toggleBiqua} className="text-2xl">
                            {isBiquaOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                    </a>
                    <div className={`absolute left-0 right-0 bottom-0 h-0.5 bg-gradient-to-r from-green-500 to-yellow-500`} />
                </div>
                {isBiquaOpen && <BiquaSidebarContent toggleSidebar={toggleSidebar} />}

                {/* Quantum Computing */}
                <div className="relative my-4">
                    <a href="#" className="flex justify-between items-center text-black text-2xl pb-4 w-full pl-4">
                        Quantum Computing
                        <button onClick={toggleQuantumComputing} className="text-2xl">
                            {isQuantumComputingOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                    </a>
                    <div className={`absolute left-0 right-0 bottom-0 h-0.5 bg-gradient-to-r from-green-500 to-yellow-500`} />
                </div>
                {isQuantumComputingOpen && <QuantumComputingSidebarContent toggleSidebar={toggleSidebar} />}

                {/* More */}
                <div className="relative my-4">
                    <a href="#" className="flex justify-between items-center text-black text-2xl pb-4 w-full pl-4">
                        More
                        <button onClick={toggleMore} className="text-2xl">
                            {isMoreOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                    </a>
                    <div className={`absolute left-0 right-0 bottom-0 h-0.5 bg-gradient-to-r from-green-500 to-yellow-500`} />
                </div>
                {isMoreOpen && <MoreSidebarContent toggleSidebar={toggleSidebar} />}

                {/* Contact */}
                <div className="relative my-4">
                    <a href="#" className="flex justify-between items-center text-black text-2xl pb-4 w-full pl-4">
                        Contact
                        <button onClick={toggleContact} className="text-2xl">
                            {isContactOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                    </a>
                    <div className={`absolute left-0 right-0 bottom-0 h-0.5 bg-gradient-to-r from-green-500 to-yellow-500`} />
                </div>
                {isContactOpen && <ContactSidebarContent toggleSidebar={toggleSidebar} />}
            </div>
        </div>
    );
};

export default Sidebar;